import components from './components';
import features from './features';
import pages from './pages';

/** The namespaces this package adds to the shared instance. */
export default {
  components,
  features,
  pages,
};
